import { columns } from './columns'
import createState from '../_defaults/state'
import createGetters from '../_defaults/getters'
import createMutations from '../_defaults/mutations'
import createActions from '../_defaults/actions'

/* -------- CONFIG ----------- */
export const apiEndpoint = '/api/companyDivision'
export const namespace = 'companyDivision'
export const clientRoute = '/company/company-division'
export const dependencies = ['company', 'division']
export const params = {
  include: 'company,division'
}
/* --------------------------- */

/* -------- LABELS ----------- */
const titleColumn = 'Division'
const subtitleColumn = 'Company'
const infoColumns = []
/* --------------------------- */

const state = {
  columns,
  apiEndpoint,
  namespace,
  dependencies,
  clientRoute,
  params,
  titleColumn,
  subtitleColumn,
  infoColumns
}

export default {
  namespaced: true,
  state: createState(Object.assign(state, { namespace })),
  getters: createGetters(),
  mutations: createMutations(),
  actions: createActions()
}
